import { render, staticRenderFns } from "./productTabList.vue?vue&type=template&id=5153d33a&"
import script from "./productTabList.vue?vue&type=script&lang=js&"
export * from "./productTabList.vue?vue&type=script&lang=js&"
import style0 from "./productTabList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports